export function getEmailFormResizeHandler({
  handleResizeModal,
  isMobileScreenSize,
}) {
  return isMobileScreenSize ? null : handleResizeModal
}
